// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Co8xo","overlay":"Loader_overlay__aoma2","loading":"Loader_loading__QV+Jy"};